import { createContext, type ReactNode, useContext, useEffect, useState } from 'react'

export type Crumb = { label: string; to?: string }

export const BreadcrumbContext = createContext<{
  crumbs: Crumb[]
  setCrumbs: (crumbs: Crumb[]) => void
}>({ crumbs: [], setCrumbs: () => {} })

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbs] = useState<Crumb[]>([])
  return (
    <BreadcrumbContext.Provider value={{ crumbs, setCrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}

/** Sets breadcrumbs for the current page. Automatically clears on unmount. */
export function useBreadcrumbs(crumbs?: Crumb[]) {
  const { setCrumbs, ...context } = useContext(BreadcrumbContext)

  // Serialise array of crumbs to prevent unnecessary re-renders
  const serialised = JSON.stringify(crumbs)

  // biome-ignore lint/correctness/useExhaustiveDependencies: serialised tracks crumbs by value
  useEffect(() => {
    if (crumbs === undefined) return
    setCrumbs(crumbs)
    return () => setCrumbs([])
  }, [serialised, setCrumbs])

  return context
}
